<template>
    <v-data-table
        :headers="headers"
        :items="filteredData"
        hide-default-footer
        class="available-species-batch-pool-table"
    >
        <!-- <template slot="item" slot-scope="props">
            <tr :data-id="props.item.ID">
                <td class="first-column">{{props.item.Name}}</td>
                <td>{{props.item.Total}}</td>
            </tr>
        </template> -->

        <template slot="item.InternalWeight" slot-scope="props">
            <td>
                <span v-if="props.item.InternalWeight && props.item.InternalWeight > 0">{{props.item.InternalWeight}}g</span>
                <span v-else></span><!-- show blank instead of "0g" -->
            </td>
        </template>

        <template slot="item.ExternalWeight" slot-scope="props">
            <td>
                <span v-if="props.item.ExternalWeight && props.item.ExternalWeight > 0">{{props.item.ExternalWeight}}g</span>
                <span v-else></span><!-- show blank instead of "0g" -->
            </td>
        </template>

        <template slot="item.TotalWeight" slot-scope="props">
            <td>
                <span v-if="props.item.TotalRemainingWeight && props.item.TotalRemainingWeight > 0">{{props.item.TotalRemainingWeight}}g</span>
                <span v-else></span><!-- show blank instead of "0g" -->
            </td>
        </template>

        <template slot="body.append">
            <tr class="totals-row">
                <td>All Species</td>
                <td>{{totalInternalWeight}}g</td>
                <td>{{totalExternalWeight}}g</td>
                <td>{{totalTotalWeight}}g</td>
            </tr>
        </template>

        <template slot="no-data">
            <v-alert outlined :value="true" type="info">
                No results found
            </v-alert>
        </template>
    </v-data-table>    
</template>

<style>
    .first-column { 
        width: 80%;
    }

    /* stop the rows from having so much space in them - note that the dense prop for v-data-table is available in an updated version of Vuetify that would also achieve this */
    #app .available-species-batch-pool-table td,
    #app .available-species-batch-pool-table th {
        padding-top: 5px;
        padding-bottom: 5px;
        height: 100%;
    }

    /* put a border around the outside of the table */
    #app .available-species-batch-pool-table table {
        border: 1px solid rgba(0,0,0,0.12);
    }

    /* make the table headers a little more obvious */
    #app .available-species-batch-pool-table th {
        font-weight: bold;
        color: black;
    }

    #app .available-species-batch-pool-table .totals-row {
        font-weight: bold;
    }
</style>

<script>

export default {
    components: {
        
    },
    props: [
        // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
        //eslint-disable-next-line
        "data"
    ],
    data() {
        return {
            
        };
    },
    computed: {
        headers() {
            return [
                {
                    text: "Species",
                    value: "SpeciesFullName",
                    sortable: false
                },
                {
                    text: "Internal",
                    value: "InternalWeight",
                    sortable: false
                },
                {
                    text: "External",
                    value: "ExternalWeight",
                    sortable: false
                },
                {
                    text: "Total (Available)",
                    value: "TotalRemainingWeight",
                    sortable: false
                },
            ];
        },
        filteredData() {
            // just in case there are completely blank values - hide them
            return this.data.filter(x => x.TotalRemainingWeight > 0);
        },
        totalInternalWeight() {
            let total = 0;

            this.data.forEach(speciesLine => {
                total += speciesLine.InternalWeight;
            });

            return total;
        },
        totalExternalWeight() {
            let total = 0;

            this.data.forEach(speciesLine => {
                total += speciesLine.ExternalWeight;
            });

            return total;
        },
        totalTotalWeight() {
            let total = 0;

            this.data.forEach(speciesLine => {
                total += speciesLine.TotalRemainingWeight;
            });

            return total;
        }
    },
    methods: {
        
    },
    created() {
        
    },
    watch: {
        
    }
};
</script>